import useSWR from 'swr';
import { fetcher } from '../base';

const popupUrl = '/popup';

export const usePopup = (skip = false) => {
  const url = skip ? null : popupUrl;
  return useSWR(url, fetcher, { revalidateOnFocus: false });
};
